import { render, staticRenderFns } from "./partnerTip.vue?vue&type=template&id=a570cf78&scoped=true"
import script from "./partnerTip.vue?vue&type=script&lang=js"
export * from "./partnerTip.vue?vue&type=script&lang=js"
import style0 from "./partnerTip.vue?vue&type=style&index=0&id=a570cf78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a570cf78",
  null
  
)

export default component.exports